module.exports = __webpack_public_path__ + "static/img/duofanghuiyi.15444e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duofanghuiyi.png
// module id = h6XT
// module chunks = 24